import React, { createContext, useContext, useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import { useLogin } from './LoginContext';
import { useNavigate } from 'react-router-dom';
import { USERCOURSEASSIGNMENT, 
    GETCOURSELIST, 
    COURSEPROGRESS, 
    GROUPASSIGNEDCOURSEONROLE, 
    COURSE_RATINGS, 
    COURSE_RATING_USERWISE, 
    COURSE_RATING_COURSEWISE } from '../utils/ApiEndPoint';
import { getCourseLessonCountByType,FixDecimalPlace } from '../utils/utils';

export const CourseContext = createContext();

export const CourseProvider = ({ children }) => {
    const navigate = useNavigate();
    const { user, logout, isLoggedIn } = useLogin();
    const [allCourse, setAllCourse] = useState([]);
    const [userCourse, setUserCourse] = useState([]);
    const [error, setError] = useState(null);
    const [addreviewRatting, setAddreviewRatting] = useState({
        status: false,
        coursetitle: '',
        courseId: '',
        rating: 0,
        review: ''
    });
    useEffect(() => {
        if (!isLoggedIn) {
            reset();
            return;
        }
        fetchAllCourse();
    }, [isLoggedIn]);
    useEffect(() => {
        if (!allCourse.length || !user?.lmsRoles || !user?.selectedRole) return;
        const userCourseAssignment = () => {
            const { userId, roles } = user;
            const data = { "userId": userId, "roleName": roles[0].roleName };
            const allPublicCourse = allCourse.filter(course => course.accessMode === 'public' && course.status === 'published');
            let tempuserCourse = []
            apiClient.post(USERCOURSEASSIGNMENT, data)
                .then((response) => {
                    if (response.status === 201) {
                        let courseData = response?.data?.assignment?.courseIds;

                        if (courseData.length) {
                            const assignedCourses = allCourse.filter(course => (courseData.includes(course._id)) && course.status === 'published');
                            tempuserCourse = [...allPublicCourse, ...assignedCourses]
                        } else {
                            tempuserCourse = [...allPublicCourse]
                        }
                    } else {
                        tempuserCourse = [...allPublicCourse]
                    }
                }).catch((error) => {
                    setError('Failed to user Course assignment by role');
                    tempuserCourse = [...allPublicCourse]
                }).finally(() => {
                    userCourseAssignmentByRole(tempuserCourse)
                });
        }

        const userCourseAssignmentByRole = (tempuserCourse) => {
            const { userId } = user;
            const data = { "userId": userId };
            let finalCourse = [...tempuserCourse];
            apiClient.post(GROUPASSIGNEDCOURSEONROLE, data)
                .then((response) => {
                    if (response.status === 200) {
                        const courseData = response?.data?.courses.map(item => item._id);
                        if (courseData.length) {
                            const assignedCourses = allCourse.filter(course => (courseData.includes(course._id)) && course.status === 'published');
                            finalCourse = [...tempuserCourse, ...assignedCourses];

                            // Remove duplicates based on _id
                            const uniqueCoursesMap = new Map();
                            finalCourse.forEach(course => {
                                uniqueCoursesMap.set(course._id, course);
                            });
                            finalCourse = Array.from(uniqueCoursesMap.values());
                        }
                    }
                }).catch((error) => {
                    setError('Failed to fetch user Course assignment by role');
                }).finally(() => {
                    // console.log("🚀 krishna  ~ finalCourse:", finalCourse);
                    getCourseProgerss(finalCourse);
                });
        }
        if (user?.selectedRole === 'viewer') {
            userCourseAssignment()
        }
        else {
            setUserCourse(allCourse);
        }
    }, [allCourse, user?.lmsRoles, user?.selectedRole]);
    const getCourseProgerss = async (allCourse) => {
        try {
            const assignedCourses = await Promise.all(
                allCourse.map(async (course) => {
                    const ratingdata = await getUserwiseCourseRating(course._id);
                    const courseRatingSummaryresponse = await getCourseRatingSummary(course._id)
                    const courseRatingSummary = {
                        averageRating: courseRatingSummaryresponse?.averageRating? FixDecimalPlace(courseRatingSummaryresponse.averageRating,1): 0,
                        totalRatings: courseRatingSummaryresponse?.totalRatings || 0,
                        ratingsBreakdown: [
                            { stars: 5, percent: 45 },
                            { stars: 4, percent: 25 },
                            { stars: 3, percent: 21 },
                            { stars: 2, percent: 5 },
                            { stars: 1, percent: 4 }
                        ]
                    }
                    const modules = course?.modules && typeof course.modules === "string" ? JSON.parse(course.modules) : [];
                    const lesson = modules.length && typeof modules[0].lessons === "string" ? JSON.parse(modules[0].lessons) : [];

                    const totalVideos = getCourseLessonCountByType(lesson, 'video');
                    const totalAssessments = getCourseLessonCountByType(lesson, 'quiz');
                    try {
                        const response = await apiClient.post(COURSEPROGRESS, {
                            userId: user?.userId,
                            userName: user?.name,
                            courseId: course?._id,
                            courseTitle: course.title,
                            totalContentCount: totalVideos + totalAssessments
                        });
                        if (response.status === 200) {
                            const progressPercent = response.data?.progressPercent || 0;
                            const usrCourseProgress = response.data?.usrCourseProgress || null;
                            return { ...course, ratingdata, courseRatingSummary, progressPercent, usrCourseProgress };
                        }
                    } catch (error) {
                        console.error("Error fetching course progress:", error);
                    }
                    return { ...course, ratingdata, courseRatingSummary, progressPercent: 0 };
                })
            );
            setUserCourse(assignedCourses);

        } catch (err) {
            setUserCourse(allCourse.map(course => ({ ...course, progressPercent: 0 })));
        }
    }
    const getCourseRatingSummary = async (courseId) => {
        try {
            const response = await apiClient.get(`${COURSE_RATING_COURSEWISE}/${courseId}/summary`);
            if (response.status === 200) {
                return { averageRating: response?.data?.avgRating ? response?.data?.avgRating : 0, 
                    totalRatings: response?.data?.totalRatings || '' }
            }
        } catch (error) {
            console.error("Error fetching course rating:", error);
        }
        return null;
    };
    const getUserwiseCourseRating = async (courseId) => {
        try {
            const response = await apiClient.get(`${COURSE_RATING_USERWISE}/${user?.userId}/course/${courseId}`);
            if (response.status === 200) {
                return { rating: response?.data?.rating ? parseInt(response?.data?.rating) : 0, review: response?.data?.review || '' }
            }
        } catch (error) {
            console.error("Error fetching course rating:", error);
        }
        return null;
    };
    const fetchAllCourse = () => {
        apiClient.get(GETCOURSELIST)
            .then((response) => {
                if (response.status === 200) {
                    const courseData = response.data;
                    setAllCourse(courseData);
                } else {
                    console.error(response);
                }
            }).catch((error) => {
                // console.error("Error fetching courses:", error);
                if (error.response && error.response.status === 401) {
                    logout();
                    navigate('/login');
                }
            }).finally(() => {

            });
    };
    const getcourseNameById = (courseId) => {
        const course = allCourse.find(c => c._id === courseId);
        return course ? course.title : 'Course Not Found';
    };
    const getCourseProgerssStatusById = (courseId) => {
        const course = userCourse.find(c => c._id === courseId);
        return course && course.progressPercent >= 100 ? true : false;
    };
    const reset = () => {
        setAllCourse([]);
        setUserCourse([]);
        setError(null);
    }
    const saveReviewRating = async (rating, courseId, review) => {
        const data = {
            "userId": user?.userId,
            "courseId": courseId,
            "rating": rating,
            "review": review
        };
        try {
            const response = await apiClient.post(COURSE_RATINGS, data);
            if (response.status === 200) {
                setUserCourse(prevCourses => prevCourses.map(course => {
                    if (course._id === courseId) {
                        return { ...course, ratingdata: { rating: response.data.rating, review: response.data.review } };
                    }
                    return course;
                }));
                return { success: true, message: "Review and rating saved successfully." };
            } else {
                return { success: false, message: "Failed to save review and rating." };
            }
        } catch (error) {
            // console.error("Failed to save review and rating:", error);
            return { success: false, message: error?.message || "Failed to save review and rating." };
        } finally {
            setAddreviewRatting(prevState => ({
                ...prevState,
                status: false,
                coursetitle: '',
                courseId: '',
                rating: '',
                review: ''
            }));
        }
    }
    const HandelAddreviewRatting = (status, courseTitle, courseRating, courseId, review) => {
        setAddreviewRatting(prevState => ({
            ...prevState,
            status: status,
            coursetitle: courseTitle,
            courseId: courseId,
            rating: courseRating,
            review: review
        }));
    }
    const getCourseDteatilById = (courseId) => {
        const course = userCourse.find(c => c._id === courseId);
        return course || null;
    }
    return (
        <CourseContext.Provider
            value={{
                allCourse,
                userCourse,
                fetchAllCourse,
                getcourseNameById,
                getCourseProgerssStatusById,
                getCourseProgerss,
                error,
                HandelAddreviewRatting,
                addreviewRatting,
                saveReviewRating,
                getCourseRatingSummary,
                getUserwiseCourseRating,
                getCourseDteatilById
            }}
        >
            {children}
        </CourseContext.Provider>
    );
};

export const useCourse = () => useContext(CourseContext);